import Promise from 'promise-polyfill'

window.Promise = (window.Promise || Promise)

// Polyfill for NodeList in IE11
NodeList.prototype.forEach = (NodeList.prototype.forEach || Array.prototype.forEach)



// WEBPACK FOOTER //
// ./client/promise-polyfill.js